import { render } from "./domandeSection.vue?vue&type=template&id=955fde9c&ts=true"
import script from "./domandeSection.vue?vue&type=script&lang=ts"
export * from "./domandeSection.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__